<template>
    <div class="cont-table">

        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>

        <div class="row cont_tot_res_holidays_permits_emt_ok">
            <div class=" " style="margin:0 auto;">
                <div class="card">

                    <div class="card-body" style="padding:0px">

                        <div class="table-responsive" style="">

                            <table id="myTable" style="margin-top:57px">
                                <thead>
                                    <tr>


                                        <th class='all'>
                                            <div class="cl_checkall">
                                                <ion-checkbox name='emailgestoreall'
                                                    style="width:10px!important;height:10px!important" class='checkall'
                                                    slot='start'>
                                                </ion-checkbox>
                                            </div>
                                        </th>


                                        <th class='all'>
                                            <div class='cl_num'>N.</div>
                                        </th>
                                        <th class='all'>Cognome</th>
                                        <th class='all'>Nome</th>
                                        <th class='all' style="text-align: right;padding-right: 6px;height: 16px;">
                                            <div class="clHeaderFerie">Ferie AP/AC (H)</div>
                                        </th>
                                        <th class='all' style="text-align: right;padding-right: 6px;height: 16px;">
                                            <div class="clHeaderPermessi">Perm. AP/AC (H)</div>
                                        </th>

                                        <th class='all' style="text-align: right;padding-right: 8px;height: 16px;">
                                            <div class="clHeaderPrenotate">Prenot. (H)</div>
                                        </th>


                                        <th class='all' style="text-align: right;padding-right: 8px;height: 16px;">
                                            <div class="clHeaderTotale">Tot. (H)</div>
                                        </th>

                                        <th class='all' style="text-align: center">
                                            Stato
                                        </th>

                                        <th class='all'>
                                            Data/Ora Mail
                                        </th>

                                    </tr>
                                </thead>

                                <tfoot>

                                    <tr>
                                        <th colspan="10">
                                        </th>
                                    </tr>
                                </tfoot>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contpopupsearch" style="display:none">

            <template>
                <modal name="popupSearch" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            <v-img alt="" src="@/assets/ricerca_emt.png" max-width="25" max-height="25" />

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="textSearch" label="">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSearch" />

                                <v-img alt="" class="btn-delete-search" contain src="@/assets/icon_delete_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Elimina filtro" @click="btnResetSearch" />

                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSearch" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>

                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>

        <div class="contpopupotpdelete" style="display:none">

            <template>
                <modal name="popupOtpDelete" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Codice OTP inviatoLe via mail

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="password" v-model="valueOtpDelete" label="" id="fldValueOtpDelete">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-delete" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelOtpDelete" />

                                <v-img alt="" class="btn-confirm-otp-delete" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmOtpDelete" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>




        <div class="contpopuptiporisorsa" style="display:none">

            <template>
                <modal name="popupOtpTipoRisorsa" :clickToClose="false" :width="262" :height="234">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Aggiungi Risorsa

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-radio-group v-model="valueTypeResource">
                                <v-radio label="Dipendente" value="DIP"></v-radio>
                                <v-radio label="Parita IVA" value="PIVA"></v-radio>
                            </v-radio-group>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-add-resource" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelTypeResource" />

                                <v-img alt="" class="btn-confirm-add-resource" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmTypeResource" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopuptsperiodo" style="display:none">

            <template>
                <modal name="popupTsPeriodo" :clickToClose="false" :width="262" :height="234">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Periodo Timesheet

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <ion-item id="itemAnno"
                                style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                    position="floating">Anno </ion-label>

                                <ion-select id="year" name="year" class='year' cancel-Text="Chiudi" done-Text=""
                                    :value="selAnno" interface="action-sheet">

                                    <ion-select-option v-for="item in anni" :key="item.value" :value='item.value'> {{
                                        item.description
                                    }}</ion-select-option>

                                </ion-select>
                            </ion-item>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <ion-item id="itemMese"
                                style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                    position="floating">Mese </ion-label>

                                <ion-select id="month" name="month" class='month' cancel-Text="Chiudi" done-Text=""
                                    :value="selMese" interface="action-sheet">

                                    <ion-select-option v-for="item in mesi" :key="item.value" :value='item.value'> {{
                                        item.desc_month
                                    }}</ion-select-option>

                                </ion-select>
                            </ion-item>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-add-resource" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelPeriodTs" />

                                <v-img alt="" class="btn-confirm-add-resource" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmPeriodTs" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupmail" style="display:none">

            <template>
                <modal name="popupMail" :clickToClose="false" :width="300" :height="500">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;font-size: 11px;color:black">

                            Anteprima Mail

                        </v-col>

                    </v-row>

                    <v-row style="margin-left:5px!important">

                        <v-col cols="12" md="12">

                            <textarea id="sec_body" name="sec_body" class="sec_body" autofocus
                                style="width:270px!important;height:400px!important"></textarea>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-send-mail" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSendMail" />

                                <v-img alt="" class="btn-confirm-send-mail" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSendMail" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>





    </div>
</template>

<script>
import apirisorse from "../utils/risorse/apirisorse";
import apiinviopresenze from "../utils/inviopresenze/apiinviopresenze";

import {
    bus
} from "../main";

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import '../assets/datatables/dataTables.dataTables.css'
import '../assets/datatables/responsive.dataTables.css'
import '../assets/datatables/fixedHeader.dataTables.css'

import $ from 'jquery';

$.fn.numberFormat = function (decimals = 2, decPoint = ',', thousandsSep = '.') {
    return this.each(function () {
        let raw = $(this).text().trim()

        // Converti da "4.468,20" o "4468,2" a "4468.2"
        let val = raw.replace(/\./g, '').replace(',', '.')

        if (!isFinite(val)) return

        let n = parseFloat(val)
        let fixed = n.toFixed(decimals)

        let parts = fixed.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
        let formatted = parts.join(decPoint)

        $(this).text(formatted)
    })
}



export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
    },

    mounted: function () {

        /*eslint-disable no-undef*/

        this.$root.$children[0].checkLogout();

        window.curCompany = window.$cookies.get("sel_filter_risorse");

        window.curSrcText = "";

        window.myVal = "";

        window.curTipoContr = "-1";

        window.perpage = 100;
        bus.$off("bottomIconClickEvent");



        $(document).ready(
            function () {

                $("body").off();

                window.uname = window.$cookies.get("username");
                var uname = window.uname;

                const args = [uname, true, ['bar', 5], {
                    foo: 'baz'
                }];
                try {
                    console.log("entering user");
                    window.flutter_inappwebview.callHandler('setLoggedUser', ...args);
                    console.log("passed");

                } catch (error) {
                    // alert(error);
                }

            }
        );

        $(document).ready(function () {


            $('body').on('ionChange', '.year', function () {

                pointerVue.selAnno = this.value;

            });

            $('body').on('ionChange', '.month', function () {

                pointerVue.selMese = this.value;

            });


            $('body').on('click', '.selaggiorna', function () {

                console.log(("EVENTO CLICK SELAGGIORNA"));

                setTimeout(() => {

                    pointerVue.showSpinner = true;
                    pointerVue.$root.$children[0].showProgress = true;

                    window.table.ajax.reload();

                }, 200);


            });



            $('body').on('keydown', '.inputfield', function (event) {

                const input = event.target;
                const value = input.value;
                const key = event.key;

                // Allow navigation keys (arrows, home, end, etc.)
                if (key.length === 1 && !(/[0-9\-,.]/.test(key))) {
                    event.preventDefault();
                    return;
                }

                // Allow only one minus sign at the beginning
                if (key === '-') {
                    if (value.includes('-') || input.selectionStart !== 0) {
                        event.preventDefault();
                    }
                    return;
                }

                // Allow only one comma
                if (key === ',') {
                    if (value.includes(',')) {
                        event.preventDefault();
                    }
                    return;
                }

                // Prevent any other non-numeric input
                if (key !== 'Backspace' && key !== 'Tab' && key !== 'Enter' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
                    if (!/[0-9]/.test(key)) {
                        event.preventDefault();
                    }
                }


            });



            $('body').on('blur', '.inputfield', function (event) {
                event.preventDefault();

                console.log(this.value);

                console.log("ID: ", $(this).attr("id"));

                if (this.value == "") {
                    this.value = "0,00";
                }
                else {

                    console.log(this.value);

                    var v_value = parseFloat(this.value.replace(",", ".")).toFixed(2);

                    console.log(v_value);


                    this.value = v_value.toString().replace(".", ",");
                }


                pointerVue.updateTotalRow($(this).attr("id"));

            });

            $('body').on('click', '.selazienda', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetAziende = true;

            });


            $('body').on('click', '#footer-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openLcHandler', ...args);

                return false;
            });

            $('body').on('click', '#privacy-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openPrivacyHandler', ...args);

                return false;
            });

            $('body').on('click', '#hdtool-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openHdHandler', ...args);

                return false;
            });


            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));

                console.log("CHECKALL: ", $(this).prop("checked"));


                if ($(this).prop("checked")) {

                    $("tr").addClass("active-row");

                    $("tr").eq(0).removeClass("active-row");

                }

                if (!$(this).prop("checked")) {

                    $("tr").removeClass("active-row");


                }

                pointerVue.hideShowButtonsSelRow();



            });





        });

        setTimeout(() => {

            this.syncAziende();

        }, 100);
        // console.log (res);

        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);


            switch (data) {

                case "btn_save":

                    this.validate();

                    break;


                case "btn_update_with_ts":

                    this.openPopupUpdateWithTs();

                    break;


                case "btn_invio_mail":

                    this.openPopupSendMail();

                    break;


                default:
                    break;

            }
        });



        this.setupButtonsGrid();

        window.start = 0;

        var pointerVue = this;

        pointerVue.setupGrid();

        this.hideShowButtons(false);

        setTimeout(() => {

            $('thead th:first div span').addClass('no-before');

            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

        }, 500);





    },
    data: () => ({

        selAnno: "",

        selMese: "",

        anni: [],

        mesi: [],

        valueTypeResource: "DIP",

        valueOtpDelete: "",


        aziende: [],

        textSearch: "",

        sheetAziende: false,
        search: '',


        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) =>
                (v && v.length <= 16) ||
                "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) =>
                (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [(v) => !!v || "Field required"],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
    }),

    computed: {

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.fld_name.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

    },

    beforeDestroy() {
        clearInterval(window.reloadGridTotHolidays);
    },

    methods: {

        openPopupSendMail: function () {

            tinymce.remove();

            var that = this;

            var v_row = null;

            var v_id = null;

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    v_row = $(this);

                    v_id = $(this).attr("data-id");

                }

            });

            var v_data_row = window.table.row(v_row.parent().parent()).data();



            var txtPrevMail = "Gentile <b>" + v_data_row.fld_name + "</b>";

            txtPrevMail = txtPrevMail + "<br><br> da un controllo ci risulta che il suo monte ore ferie / permessi arretrati e attuali sia troppo elevato";

            var v_ferie_ap = $("#ferie_ap_" + v_id).val();
            var v_permessi_ap = $("#permessi_ap_" + v_id).val();


            txtPrevMail = txtPrevMail + "<br><br>Ferie (Ore): <b>" + v_ferie_ap + "</b>";

            txtPrevMail = txtPrevMail + "<br><br>Permessi (Ore): <b>" + v_permessi_ap + "</b>";

            txtPrevMail = txtPrevMail + "<br><br>Le chiediamo pertanto di incominciare a pianificare le ferie / permessi fino a fine anno";

            txtPrevMail = txtPrevMail + "<br><br>Le ricordiamo altresì che lei matura ogni mese 14,444 ore di ferie e circa 8 ore di permessi";

            if (v_data_row.companyid == 7) {

                txtPrevMail = txtPrevMail + "<br><br>Cordiali Saluti<br>LC-Service srl";

            }

            if (v_data_row.companyid == 8) {

                txtPrevMail = txtPrevMail + "<br><br>Cordiali Saluti<br>ARIALL srl";

            }


            $(".contpopupmail").show();

            that.$modal.show('popupMail');


            setTimeout(() => {

                tinymce.init({
                    selector: '#sec_body',  // change this value according to your HTML

                    plugin: 'a_tinymce_plugin',
                    height: "370",
                    mode: "textareas",
                    entity_encoding: "raw",
                    add_unload_trigger: false,
                    remove_linebreaks: false,
                    apply_source_formatting: false,
                    force_br_newlines: true,
                    force_p_newlines: false,
                    forced_root_block: '', // Needed for 3.x

                    a_plugin_option: true,
                    a_configuration_option: 400

                });

                setTimeout(() => {
                    tinymce.activeEditor.setContent(txtPrevMail);

                }, 700);

            }, 500);


        },

        btnCancelSendMail: function () {

            this.$modal.hide('popupMail');

        },

        btnConfirmSendMail: function () {

            var errore = "";

            var txt_body = tinymce.activeEditor.getContent();

            if (txt_body == "") {
                errore = "Specificare un testo per la mail";
            }

            if (errore == "") {

                console.log("ok");

                this.sendMail();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }


        },

        sendMail: async function () {


            var that = this;

            var v_row = null

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    v_row = $(this);

                }

            });

            var v_data_row = window.table.row(v_row.parent().parent()).data();

            that.$modal.hide('popupMail');

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            response = await apirisorse.sendMailHolidaysPermits(
                tinymce.activeEditor.getContent(),
                v_data_row.login
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from sendMailHolidaysPermits", res);

                if (res.data.Result == "OK") {

                    that.$swal({
                        icon: "success",
                        text: "Mail inviata correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });

                    setTimeout(() => {


                        window.table.ajax.reload();

                        that.hideShowButtons(false);


                    }, 2000);


                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 2000
                    });


                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },


        updateTotalsWithTs: async function () {


            var that = this;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("user-id");
                }

            });

            that.$modal.hide('popupTsPeriodo');

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            response = await apirisorse.updateTotalsWithTs(
                ids,
                that.selAnno,
                that.selMese
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from updateTotalsWithTs", res);

                if (res.data.Result == "OK") {

                    that.$swal({
                        icon: "success",
                        text: "Totali aggiornaeti correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });


                    setTimeout(() => {


                        window.table.ajax.reload();

                        that.hideShowButtons(false);


                    }, 2000);


                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 2000
                    });


                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },





        openPopupUpdateWithTs: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiinviopresenze.getFilterData(
                v_token,
                "emt"
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getFilterData", res);

                that.anni = res.data.year;

                that.mesi = res.data.month;

                that.selAnno = "";

                that.selMese = "";

                setTimeout(() => {

                    $(".contpopuptsperiodo").show();

                    that.$modal.show('popupTsPeriodo');


                }, 200);



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },


        btnCancelPeriodTs: function () {

            this.$modal.hide('popupTsPeriodo');

        },

        btnConfirmPeriodTs: function () {

            var that = this;

            var errore = "";

            if (that.selAnno == "") {
                errore = "Specificare l'anno";
            }

            if (errore == "") {
                if (that.selMese == "") {
                    errore = "Specificare il mese";
                }
            }

            if (errore == "") {

                console.log("ok");

                this.updateTotalsWithTs();
            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }


        },


        saveData: async function (v_array_data) {


            var that = this;


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            response = await apirisorse.saveTotHolidaysResources(
                JSON.stringify(v_array_data)
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from saveTotHolidaysResources", res);

                if (res.data.Result == "OK") {

                    that.$swal({
                        icon: "success",
                        text: "Dati salvati correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });


                    setTimeout(() => {


                        window.table.ajax.reload();

                        that.hideShowButtons(false);


                    }, 2000);


                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 2000
                    });


                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },

        validate() {

            var errore = "";

            var array_data = [];

            $(".clSurname").each(function (index) {

                console.log(index);

                var v_name = $(this).attr("val-name");
                var v_surname = $(this).attr("val-surname");
                var v_id = $(this).attr("val-id");

                // ferie ap
                var v_key = "#ferie_ap_" + v_id.toString();
                var v_ferie_ap = $(v_key).val();

                // permessi ap
                v_key = "#permessi_ap_" + v_id.toString();
                var v_permessi_ap = $(v_key).val();

                // ferie ac
                v_key = "#ferie_ac_" + v_id.toString();
                var v_ferie_ac = $(v_key).val();

                // permessi ac
                v_key = "#permessi_ac_" + v_id.toString();
                var v_permessi_ac = $(v_key).val();


                array_data.push({
                    v_name: v_name,
                    v_surname: v_surname,
                    v_id: v_id,
                    v_ferie_ap: v_ferie_ap,
                    v_permessi_ap: v_permessi_ap,
                    v_ferie_ac: v_ferie_ac,
                    v_permessi_ac: v_permessi_ac,
                });



            });




            for (var x = 0; x < array_data.length; x++) {

                if (errore == "") {

                    if ((parseFloat(array_data[x].v_ferie_ap) < -1000) || (parseFloat(array_data[x].v_ferie_ap) > 1000)) {


                        errore = "Il valore di Ferie AP deve essere compreso tra -1000 e 1000 per la risorsa " + array_data[x].v_surname + " " + array_data[x].v_name;


                    }

                }

                if (errore == "") {

                    if ((parseFloat(array_data[x].v_permessi_ap) < -1000) || (parseFloat(array_data[x].v_permessi_ap) > 1000)) {


                        errore = "Il valore di Permessi AP deve essere compreso tra -1000 e 1000 per la risorsa " + array_data[x].v_surname + " " + array_data[x].v_name;


                    }

                }

                if (errore == "") {

                    if ((parseFloat(array_data[x].v_ferie_ac) < -1000) || (parseFloat(array_data[x].v_ferie_ac) > 1000)) {


                        errore = "Il valore di Ferie AC deve essere compreso tra -1000 e 1000 per la risorsa " + array_data[x].v_surname + " " + array_data[x].v_name;


                    }

                }


                if (errore == "") {

                    if ((parseFloat(array_data[x].v_permessi_ac) < -1000) || (parseFloat(array_data[x].v_permessi_ac) > 1000)) {


                        errore = "Il valore di Permessi AC deve essere compreso tra -1000 e 1000 per la risorsa " + array_data[x].v_surname + " " + array_data[x].v_name;


                    }

                }



            }


            if (errore == "") {


                console.log("ok");

                this.saveData(array_data);

            }
            else {


                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });


            }

        },


        btnResetSearch: function () {

            window.curSrcText = "";

            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();
        },

        syncAziende: function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            setTimeout(() => {

                that.$root.$children[0].showProgress = false;

                that.aziende = JSON.parse(window.$cookies.get("companyUser"));

            }, 300);


        },

        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            window.curCompany = azienda.companyid;

            window.$cookies.set("sel_filter_risorse", azienda.companyid, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        btnCancelSearch: function () {

            this.$modal.hide('popupSearch');

        },


        btnConfirmSearch: function () {

            console.log("ok");

            window.curSrcText = this.textSearch;

            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        hideShowButtonsSelRow: function () {

            var tot = 0;

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    tot = tot + 1;

                }

            });

            setTimeout(() => {

                var pulsantis = [];


                pulsantis.push({
                    text: "Salva",
                    icon: "mdi-content-save",
                    link: "/timesheet",
                    id: "btn_save",
                    disabled: false,
                    image: "https://app.emtool.eu/public/_lib/img/icon_save_emt.png",
                    title: "Salva",
                    width: 30
                });

                if (tot == 1) {

                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/invio-emt.png",
                        link: "/info",
                        id: "btn_invio_mail",
                        disabled: false,
                        title: "Invio Mail",
                        width: 30
                    });

                }


                if (tot > 0) {


                    pulsantis.push({
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: this.getUrlDomain("public/_lib/img/timesheet3.png"),
                        link: "/info",
                        id: "btn_update_with_ts",
                        disabled: false,
                        title: "Aggiorna Totali Con Timesheet Del Periodo",
                        width: 30
                    });



                }




                this.$root.$children[0].bnavbuttons = pulsantis;



            }, 100);



        },



        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + nome_metodo;

        },

        setupGrid: function () {

            var pointerVue = this;

            $(document).ready(function () {

                var v_token = window.$cookies.get("token");



                window.curStatus = "S"; // in forza

                window.columns = [{
                    data: 'sel_row',
                    orderable: false,
                    searchable: false,
                    name: '',
                    width: '1%',
                },

                {
                    data: 'DT_RowIndex',
                    orderable: true,
                    searchable: false,
                    name: '',
                    width: '1%',
                },

                {
                    data: 'surname',
                    orderable: true,
                    name: 'surname',
                    width: '5%'
                },

                {
                    data: 'name',
                    orderable: true,
                    name: 'name',
                    width: '5%'
                },

                {
                    data: 'ferie_ap',
                    orderable: false,
                    name: 'ferie_ap',
                    width: '5%'
                },

                {
                    data: 'permessi_ap',
                    orderable: false,
                    name: 'permessi_ap',
                    width: '7%'
                },

                {
                    data: 'ore_prenotate',
                    orderable: true,
                    name: 'ore_prenotate',
                    width: '7%'
                },

                {
                    data: 'totale',
                    orderable: true,
                    name: 'totale',
                    width: '7%'
                },


                {
                    data: 'stato',
                    orderable: false,
                    name: 'stato',
                    width: '1%'
                },


                {
                    data: 'last_date_sent_mail_holidays',
                    orderable: true,
                    name: 'last_date_sent_mail_holidays',
                    width: '10%',

                    render: function (data, row) {
                        console.log(data, row);

                        var html = "";

                        if (data != null) {


                            var date = "";
                            try {

                                date = data.substring(0, 10);
                            } catch (error) {
                                console.log(error);
                            }

                            var hour = "";
                            try {

                                hour = data.split(" ")[1].slice(0, 5);
                            } catch (error) {
                                console.log(error);
                            }

                            html = "<div class='font-row-grid-datetime2'><div class='cl-time'>" + hour + "</div><div class='cl-date'>" + date + "</div></div>";


                        }



                        return html;
                    }

                },

                ];



                $(".spin").show();




                window.table = $('#myTable').DataTable({
                    // dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                    //     "<'rows colcontTable'<'col-sm-12 'tr>>" +
                    //     "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,

                    ajax: {
                        url: pointerVue.getUrlDomain("EmtGetRisorseTotHolPermitsApi") + '?username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start = window.perpage;

                            valori.start = 0;
                            valori.length = window.perpage;

                            valori.curCompany = window.curCompany;
                            valori.curStatus = window.curStatus;

                            valori.curSrcText = window.curSrcText;

                            valori.curTipoContr = window.curTipoContr;

                            window.valori = valori;
                            return valori;

                        }

                    },

                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTable_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        setTimeout(function () {

                            pointerVue.showSpinner = false;
                            pointerVue.$root.$children[0].showProgress = false;

                        }, 700);


                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();

                        setTimeout(() => {


                            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

                        }, 500);


                        $('.dt-type-numeric').removeClass('dt-type-numeric');
                        $('.dt-type-date').removeClass('dt-type-date');



                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTable_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();

                            setTimeout(() => {

                                $(".spin").hide();

                            }, 500);

                            var valori = window.valori;
                            valori.start = window.start;

                            $.ajax({
                                url: pointerVue.getUrlDomain("EmtGetRisorseTotHolPermitsApi") + '?username=' + v_token,
                                data: window.valori,
                                success: function (data) {
                                    // $(".spin").hide();
                                    window.loading = 0;
                                    window.start += window.perpage;

                                    for (let [index, val] of data.data.entries()) {
                                        console.log(index, val);
                                        window.table.row.add(val).draw(false);
                                        //  window.dataset.push(val);
                                    }
                                    console.log(data.data);
                                },
                            });
                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTable_wrapper .dt-layout-row").first().find("div").remove();

                $("#myTable_wrapper .dt-layout-end").remove();


                var sel = `
                <img src='/emt/img/refresh-emt.png' style='border:0!important;' class='selaggiorna' title='Aggiorna' /><img src='/emt/img/aziende-emt.png' style='border:0!important;' class='selazienda' title='Aziende' />
                  `;


                  
                  $("#myTable_wrapper .dt-layout-row").first().prepend(`
                <div class="cont_buttons">

                    <div class="text_title">Ferie / Permessi</div>
                    ` + sel + `

                </div>
                <div><img src='/emt/img/cerca-emt.png' style='border:0!important;' class='selricerca' title='Ricerca' /></div>

            `);

                $(".selricerca").on("click", function (opt) {
                    console.log(opt);

                    pointerVue.textSearch = "";

                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                });


                $('body').on('click', '.paginate_button', function () {
                    $(".spin").show();

                });

                $('body').on('click', '.refreshButton', function () {

                    $(".spin").show();
                    window.table._fnDraw();

                });



                $(".selecttipocontr").on("ionChange", function (opt) {
                    console.log(opt);
                    $(".spin").show();

                    window.curTipoContr = this.value;

                    window.table.ajax.reload();

                });





                $(".selectstatusall").on("ionChange", function (opt) {
                    console.log(opt);
                    $(".spin").show();
                    window.curStatus = this.value;



                    window.table.ajax.reload();

                });

                // $('body').on('click', '.cont_tot_res_holidays_permits_emt_ok th', function () {


                //     console.log("TH-ACTIVE: ", $(this));


                //     $(this).removeClass("sorting");



                // });


                $('body').on('click', '.cont_tot_res_holidays_permits_emt_ok tr', function () {

                    console.log("TR-ACTIVE");

                    setTimeout(() => {

                        var row_data = window.table.row(this).data();

                        if (row_data != null) {


                            console.log("ROW DATA: ", row_data);


                            var last_id_sel = $("tr.active-row").find(".id_row").attr("data-id");

                            var id_sel = $(this).find(".id_row").attr("data-id");


                            var set_cls_active = 0;

                            if (last_id_sel == "undefined") {
                                set_cls_active = 1;
                            } else {
                                if (last_id_sel != id_sel) {
                                    set_cls_active = 1;
                                }
                            }

                            console.log("ROM IS ACTIVE: ", set_cls_active);



                            console.log("THIS: ", this);

                            var hasClassActive = $(this).hasClass("active-row");

                            if (hasClassActive) {

                                console.log("ACTIVE-ROW");

                                $(this).find(".val_status").prop("checked", false);

                                $(this).removeClass("active-row");


                            }

                            if (!hasClassActive) {

                                console.log("NOT ACTIVE-ROW");

                                $(this).find(".val_status").prop("checked", true);

                                $(this).addClass("active-row");



                            }

                            window.id_par_sel = $("tr.active-row").find(".id_row").attr("data-id");

                            if (window.id_par_sel == undefined) {
                                window.id_par_sel = id_sel;
                            }

                            console.log("ID SELECTED: ", window.id_par_sel);


                            console.log("FIND VAL_STATUS: ", $(this).find(".val_status"));

                            var find_check = $(this).find(".val_status");
                            if (find_check.is(":checked")) {
                                console.log("SELEZIONATO");

                            }

                            if (!find_check.is(":checked")) {
                                console.log("DESELEZIONATO");

                            }


                            pointerVue.hideShowButtonsSelRow();


                        }



                    }, 100);




                });



                window.parentiAddedEvents = true;

            });

        },


        hideShowButtons: async function (v_enable) {

            setTimeout(() => {

                var pulsantis = [];

                if (v_enable == false) {

                    pulsantis = [

                        {
                            text: "Salva",
                            icon: "mdi-content-save",
                            link: "/timesheet",
                            id: "btn_save",
                            disabled: false,
                            image: "https://app.emtool.eu/public/_lib/img/icon_save_emt.png",
                            title: "Salva",
                            width: 30
                        },



                    ];

                }

                if (v_enable == true) {

                    pulsantis = [

                        {
                            text: "Add",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                            link: "/settings",
                            id: "btn_add",
                            disabled: false,
                            title: "Aggiungi",
                            width: 30
                        },

                        {
                            text: "Edit",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                            link: "/info",
                            id: "btn_edit",
                            disabled: false,
                            title: "Modifica",
                            width: 30
                        },

                        {
                            text: "Delete",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                            link: "/info",
                            id: "btn_delete",
                            disabled: false,
                            title: "Elimina",
                            width: 30
                        },

                        // {
                        //     text: "Indietro",
                        //     icon: "mdi-arrow-left",
                        //     image: "https://app.emtool.eu/public/_lib/img/back-emt.png",
                        //     link: "/confOrariChoice",
                        //     id: "btn_back",
                        //     disabled: false,
                        //     title: "Indietro",
                        //     width: 35
                        // },





                    ];

                }

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtonsGrid: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/dash",
                        id: "btn_exit",
                        disabled: false,
                    },

                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        setupButtons: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/qrconfirm",
                        id: "btn_qrcode",
                        image: "https://app.smart-book.it/public/smartbook/ICON_3.png",
                        disabled: false,
                    },

                    {
                        text: "Settings",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-settings-64.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_settings",
                        disabled: false,
                    },

                    {
                        text: "Info",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-informazioni-482.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_info",
                        disabled: false,
                    },

                    {
                        text: "Pdf",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/sb-export-pdf-50.png",
                        class: "inverted",
                        link: "/pdf",
                        id: "btn_pdf",
                        disabled: false,
                    },

                ];

                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },



        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
      console.log('a phone number was clicked');
    }
,
 */
        reply(par) {
            console.log(par);
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },


    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>


.no-before::before {
    content: none !important;
}


table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    margin-right: 0.5em !important;
    display: block !important;
    box-sizing: content-box !important;
    content: "+" !important;
    color: white !important;
    top: 50% !important;
    left: 5px !important;
    height: 1em !important;
    width: 1em !important;
    margin-top: -9px !important;
    border: .15em solid white !important;
    border-radius: 1em !important;
    box-shadow: 0 0 .2em #444 !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-family: "Courier New", Courier, monospace !important;
    line-height: 1em !important;
    background-color: #a4a4b0 !important;
    transform: translate(0px, 0px) !important;
}


.cont_tot_res_holidays_permits_emt_ok #myTable_wrapper>.dt-layout-row:first-of-type {
    top: 66px;
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border: 1px solid #ffd212;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0px;
}

.cont_tot_res_holidays_permits_emt_ok .cl_num {
    margin-right: 11px !important;
}

.cl-date {
    font-size: 10px;
    color: gray;
}


.font-row-grid-datetime2 {
    font-size: 10px !important;
    padding: 0px !important;
    width: 100px !important;
    margin: 0px !important;
    height: 10px !important;
    margin-top: -13px !important;
}


.clHeaderPermessi {
    width: 115px;
    min-width: 115px;
    max-width: 115px;
    float: right;
}

.clHeaderFerie {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    float: right;
}


.clHeaderTotale {
    width: 45px;
    min-width: 45px;
    max-width: 45px;
    float: right;
}

.clHeaderPrenotate {
    width: 54px;
    min-width: 54px;
    max-width: 54px;
    float: right;
}

.clContentInputField {
    display: flex !important;
    justify-items: right !important;
    align-items: end !important;
    justify-content: right !important;
    width: 100% !important;
    height: 20px !important;
}



.clSurname {
    font-size: 13px;
    font-weight: bold;
}

.cont_tot_res_holidays_permits_emt_ok .clName {
    font-size: 13px;
    font-weight: bold;
    width: 96px;
}


.cont_tot_res_holidays_permits_emt_ok .selaggiorna {
    max-width: 22px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}



.inputfield {
    font-size: 11px !important;
    border: 1px solid black !important;
    min-width: 65px !important;
    max-width: 65px !important;
    width: 65px !important;
    height: 20px !important;
    min-height: 20px !important;
    max-height: 20px !important;
    padding-left: 5px !important;
    text-align: right !important;
    padding-right: 5px !important;
}



#fldValueOtpDelete {
    text-align: center;
    font-size: 20px
}

.dataTable tbody tr,
.dataTable tbody tr td {
    vertical-align: middle;
    padding: 6px !important;
}

.pay {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #f5cf2e;

}

.pay a {
    color: #f5cf2e;

    -webkit-transition: background-color 2s ease-out;
    -moz-transition: background-color 2s ease-out;
    -o-transition: background-color 2s ease-out;
    transition: background-color 2s ease-out;

}

.pay a:hover {
    color: #f5cf2e;
}

.plan {
    margin-top: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;

}

.policy {
    text-align: center;
    margin-top: 30px;
}

.version {
    font-size: 10px;
    margin-top: 25px;
    text-align: center;
}

.version span {
    font-size: 13px;
}

.titleproduct {
    font-size: 16px;
    font-size: 16px;
    color: #rgb(245, 207, 46);
    font-weight: 800;

    text-align: center;
    margin-top: 40px;

}

.Absolute-Center {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
}

.logo {
    text-align: center;
}


ion-items {
    min-width: 60px;

}

ion-items ion-datetime {
    margin-left: 25px;
}

.colcontTable .col-sm-12 {
    padding:
        0px;
}

.selectpianiall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    /* border-radius: 12px; */
    /* min-height: 12px; */
    /* transform: translateY(-2px); */
    background-image: url(/smartb/img/FiltroNucleo.png);
    /* padding: 1px 11px; */
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    transform: translateY(2px);
}


.cont-table .spin {

    display: flex;
    position: absolute;
    z-index: 100;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

.cont_tot_res_holidays_permits_emt_ok #myTable {
    margin-right: 3px;
    width: 885px !important;
}

.cont_tot_res_holidays_permits_emt_ok table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_tot_res_holidays_permits_emt_ok table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
    padding-top: 5px !important;
    vertical-align: middle;
}

.cont_tot_res_holidays_permits_emt_ok th {
    padding-left: 5px !important;
}

.cont_tot_res_holidays_permits_emt_ok ion-datetime.dateBook {
    margin-left: 16px;
}

.cont_tot_res_holidays_permits_emt_ok .table-responsive {
    padding: 0px;
    min-width: 90vw;
    max-width: 100vw;
}


.cont_tot_res_holidays_permits_emt_ok #myTable_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border-color: #f5cf2e;

}

.cont_tot_res_holidays_permits_emt_ok div.dataTables_wrapper div.dataTables_filter input {
    /* margin-top:5px!important */
}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cont_tot_res_holidays_permits_emt_ok #myTable_wrapper {
    padding-top: 0px;
    min-width: 900px;
    max-width: 900px;
    width: 900px;
    padding-bottom: 115px !important;
}

.cont_tot_res_holidays_permits_emt_ok .text_title {
    background-color: white;
    color: black;
    font-weight: bold;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0px;
    font-size: 10px;
    min-width: 0vw
}

.cont_tot_res_holidays_permits_emt_ok .selazienda {
    max-width: 23px;
    min-height: 23px;
    margin-left: 6px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;

}

.cont_tot_res_holidays_permits_emt_ok .selupdwithts {
    max-width: 25px;
    min-height: 25px;
    margin-left: 6px;
    color: black !important;
    padding: 0px 0px;
    min-width: 25px !important;
    text-indent: -119px;
    background-size: 25px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;

}

.cont_tot_res_holidays_permits_emt_ok .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}

.cont_tot_res_holidays_permits_emt_ok .selectstatusall {
    max-width: 22px;
    min-height: 22px;
    margin-left: 13px;
    color: black !important;
    padding: 0px 0px;
    min-width: 44px !important;
    background-image: url(/emt/img/filtro-stato-emt.png);
    text-indent: -119px;
    background-size: 27px !important;
    background-repeat: no-repeat;
    transform: translateY(2px);
    margin-top: -8px !important;
}

.cont_tot_res_holidays_permits_emt_ok .selecttipocontr {
    max-width: 23px;
    min-height: 23px;
    margin-left: 13px;
    color: black !important;
    padding: 0px 0px;
    min-width: 44px !important;
    background-image: url(/emt/img/tipo_contratto_emt.png);
    text-indent: -119px;
    background-size: 27px !important;
    background-repeat: no-repeat;
    transform: translateY(2px);
    margin-top: -8px !important;
}



.cont_tot_res_holidays_permits_emt_ok .cont_buttons {
    display: flex !important;
    align-items: center !important;
    float: left !important;
    min-width: 95px !important;
    padding-left: 10px !important;
    justify-content: inherit !important;
}

.action-sheet-button-inner.sc-ion-action-sheet-ios {
    color: black !important;
}

.cl_tipo_contratto {
    width: 46px !important;
}

.cont_tot_res_holidays_permits_emt_ok .cl_desc_company {
    width: 140px !important;
}

.cl_inizio_rapporto {
    width: 70px !important;
}

.cl_fine_rapporto {
    width: 70px !important;
}

.cl_totale_ferie {
    width: 60px !important;
}

.cl_costo_giornaliero {
    width: 75px !important;
}

.cl_diaria {
    width: 52px !important;
}

.cl_piano_orario {
    width: 48px !important;
}

.cl_customer_date_start {
    width: 55px !important;
}

.cl_customer_date_end {
    width: 55px !important;
}

.cont_tot_res_holidays_permits_emt_ok .cl_checkall {
    padding-left: 1px;
    padding-top: 2px;
}

.cont_tot_res_holidays_permits_emt_ok .checkall {
    width: 13px;
    height: 13px;
}

.cont_tot_res_holidays_permits_emt_ok .val_status {
    width: 10px !important;
}

.cont_tot_res_holidays_permits_emt_ok .selricerca {
    max-width: 31px;
    min-height: 31px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-right: 14px !important;
}

.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.itemAzienda {
    margin-left: 15px;
}

.contpopuptiporisorsa .v-label {
    font-size: 10px !important;
}


@media screen and (max-width: 960px) {

    .cont_tot_res_holidays_permits_emt_ok .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    .cont_tot_res_holidays_permits_emt_ok #myTable {
        /* margin-top:54px; */
    }

    .cont_tot_res_holidays_permits_emt_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

}

@media screen and (max-width: 1024px) {

    .contIcon {
        display: inherit;
    }



    .cont_tot_res_holidays_permits_emt_ok #myTable {
        max-width: 100vw !important;
        margin-right: 0px;
        min-width: 100vw !important;
        position: relative;
        width: 100vw !important;

    }

    .cont_tot_res_holidays_permits_emt_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

    .cont_tot_res_holidays_permits_emt_ok .table-responsive {
        padding: 0px;
        min-width: 95vw !important;
        max-width: 95vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_tot_res_holidays_permits_emt_ok #myTable_wrapper {
        min-width: initial;
        min-width: 100vw !important;
        max-width: 100vw !important;
        width: 100vw !important;
        overflow-x: auto !important;
    }

    .cont_tot_res_holidays_permits_emt_ok .cl_num {
        margin-left: -1px !important;
    }

    .cl_n_matricola {
        display: inline-flex;
    }

    .cl_desc_project {
        display: inline-flex;
    }

    .cl_costo_giornaliero {
        display: inline-flex;
    }

    .cl_diaria {
        display: inline-flex;
    }

    .cl_ticket {
        display: inline-flex;
    }

    .cl_piano_orario {
        display: inline-flex;
    }

    .cl_ebadge {
        display: inline-flex;
    }

    .cl_totale_ferie {
        display: inline-flex;
    }

    .cl_tipo_contratto {
        display: inline-flex;
    }

    .cl_desc_company {
        display: inline-flex;
    }

    .cl_inizio_rapporto {
        display: inline-flex;
    }

    .cl_fine_rapporto {
        display: inline-flex;
    }

    .cont_tot_res_holidays_permits_emt_ok .cl_checkall {
        padding-left: 1px;
        padding-top: 2px;
    }

    .inputfield {
        font-size: 11px !important;
        border: 1px solid black !important;
        min-width: 65px !important;
        max-width: 65px !important;
        width: 65px !important;
        height: 20px !important;
        min-height: 20px !important;
        max-height: 20px !important;
        padding-left: 5px !important;
        text-align: right !important;
        padding-right: 5px !important;
    }

    .clHeaderPermessi {
        width: 90px;
    }


}
</style>
